import { AxiosResponse } from 'axios';

import axiosInstance from '../base';

import {
  normalizeFiltersPresets,
  normalizePortalOrganizationSettings,
  normalizePortalUserConfig,
} from './normalizers';
import {
  IActivateFilterPayload,
  IActivePreset,
  IAmountDisplayPayload,
  IFilterPayload,
  IOrganizationSettings,
  IOrganizationThemePayload,
  IPortalUserConfig,
  ISavedPreset,
  IUserConfigPayload,
} from './types';

// const userId = '';
// const organizationId = '';

const portalUserAPI = {
  async getUserConfig(): Promise<IPortalUserConfig> {
    const result = await axiosInstance.get(`customizations/users/configurations`);
    // const result = await customizationInstance.get(`users/${userId}/configuration`);

    return normalizePortalUserConfig(result.data);
  },

  async saveUserConfigParam(payload: IUserConfigPayload): Promise<IPortalUserConfig> {
    const result = await axiosInstance.post(
      `customizations/users/configurations`,
      payload,
    );
    // const result = await customizationInstance.post(
    //   `users/${userId}/configuration`,
    //   payload
    // );

    return normalizePortalUserConfig(result.data);
  },

  async getOrganizationSettings(): Promise<IOrganizationSettings> {
    const { data } = await axiosInstance.get(`customizations/merchants/themes`);
    // const { data } = await customizationInstance.get(
    //   `organizations/${organizationId}/themes`
    // );

    return normalizePortalOrganizationSettings(data);
  },

  async saveOrganizationTheme({
    canApply: _,
    organizationId,
    ...payload
  }: IOrganizationThemePayload): Promise<IOrganizationSettings> {
    const { data } = await axiosInstance.put(
      `customizations/merchants/${organizationId}/themes`,
      payload,
    );
    // const { data } = await customizationInstance.post(
    //   `organizations/${organizationId}/themes`,
    //   payload
    // );

    return normalizePortalOrganizationSettings(data);
  },

  async saveFiltersPreset(data: IFilterPayload): Promise<ISavedPreset> {
    const response = await axiosInstance.post(
      `customizations/users/configurations/filters-presets`,
      data,
    );
    // const response = await customizationInstance.post(
    //   `users/${userId}/configuration/filters-presets`,
    //   data
    // );

    return normalizeFiltersPresets(response.data);
  },

  async activateFiltersPreset({
    presetId,
    ...data
  }: IActivateFilterPayload): Promise<AxiosResponse> {
    const response = await axiosInstance.put(
      `customizations/users/configurations/filters-presets/${presetId}`,
      data,
    );
    // const response = await customizationInstance.put(
    //   `users/${userId}/configuration/filters-presets/${presetId}`,
    //   data
    // );

    return response.data;
  },

  async deleteFiltersPreset({
    pageKey,
    presetId,
  }: IActivateFilterPayload): Promise<IActivePreset> {
    const response = await axiosInstance.post(
      `customizations/users/configurations/filters-presets/${presetId}`,
      { pageKey },
    );
    // const response = await customizationInstance.post(
    //   `users/${userId}/configuration/filters-presets/${presetId}`,
    //   { pageKey }
    // );

    return {
      activePreset: (response.data?.activePreset as string) || null,
    };
  },

  async saveAmountDisplayConfig(payload: IAmountDisplayPayload): Promise<void> {
    await axiosInstance.post(
      `customizations/users/configurations/amount-display`,
      payload,
    );
    // await customizationInstance.post(
    //   `users/${userId}/configuration/amount-display`,
    //   payload
    // );
  },

  async resetAmountDisplayConfig(pageKey: string): Promise<void> {
    await axiosInstance.delete(`customizations/users/configurations/amount-display`, {
      params: { pageKey },
    });
    // await customizationInstance.delete(
    //   `users/${userId}/configuration/amount-display`,
    //   { params: { pageKey } }
    // );
  },
};

export default portalUserAPI;
